module.exports = __webpack_public_path__ + "img/chevrone-black.2b116fc5.svg";